import * as yup from 'yup'

// yup.addMethod(yup.object,
//   'plateRequired',
//   function () {
//     return this
//       .shape({
//         letter:  yup.string().min(1, 'حرف مربوط به پلاک را انتخاب کنید').required('حرف پلاک الزامی است'),
//         two_digits: yup.string().min(2, 'برای رقم سمت چپ حداقل دو کاراکتر وارد کنید').required('رقم سمت چپ الزامی است'),
//         three_digits: yup.string().min(3, 'برای رقم سمت راست حداقل سه کاراکتر وارد کنید').required('رقم سمت راست الزامی است'),
//         number_base: yup.string().min(2,'برای رقم آخر پلاک حداقل دو کاراکتر وارد کنید').required('عدد آخر پلاک الزامی است'),
//       })
//   })

yup.addMethod(yup.object, 'plateRequired', function () {
  return this.test(
    'plate-required',
    'اطلاعات پلاک کامل نیست',
    function (value) {
      const { letter, two_digits, three_digits, number_base } = value;

      if (!!!letter || letter.length < 1) {
        return this.createError({
          path: `${this.path}.letter`,
          message: 'حرف پلاک الزامی است',
        });
      }

      if (!!!two_digits || two_digits.length < 2) {
        return this.createError({
          path: `${this.path}.two_digits`,
          message: 'برای رقم سمت چپ حداقل دو کاراکتر وارد کنید',
        });
      }

      if (!!!three_digits || three_digits.length < 3) {
        return this.createError({
          path: `${this.path}.three_digits`,
          message: 'برای رقم سمت راست حداقل سه کاراکتر وارد کنید',
        });
      }

      if (!!!number_base || number_base.length < 2) {
        return this.createError({
          path: `${this.path}.number_base`,
          message: 'عدد آخر پلاک الزامی است',
        });
      }

      return true;
    }
  );
});


yup.addMethod(
  yup.string,
  'mobileNumber',
  function (message) {
    return this.test(
      'mobile-number',
      message || 'شماره موبایل معتبر نیست',
      function (value) {
        if (!value) return true; // بذار required تصمیم بگیره
        const v = value.replace(/\s+/g, '');
        return /^(?:\+98|0098|0)?9\d{9}$/.test(v);
      }
    );
  }
);




yup.addMethod(
  yup.string,
  'stringNullable',
  function (message) {
    return this
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      )
      .nullable().typeError(message || 'مقدار باید یک رشته باشد')
  })

yup.addMethod(
  yup.number,
  'numberNullable',
  function (message) {
    return this
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      )
      .nullable().typeError(message || 'مقدار باید یک عدد باشد')
  })


// اگه یکی از مقادیر پلاک وارد شد آن وقت همه باید وارد شود؛ در غیر این صورت اختیاری است
yup.addMethod(yup.object,
  'plateAllOrNothing',
  function (message) {
    return this
      .shape({
        letter:  yup.string().transform(v => (v === '' ? null : v)).nullable().min(1),
        two_digits: yup.string().transform(v => (v === '' ? null : v)).nullable().min(2),
        three_digits: yup.string().transform(v => (v === '' ? null : v)).nullable().min(3),
        number_base: yup.string().transform(v => (v === '' ? null : v)).nullable().min(2),
      }).test(
      'plate-all-or-nothing',
      message || 'در صورت وارد کردن پلاک، تکمیل همه بخش‌های پلاک الزامی است',
      function (value) {
        if (!value) return true

        const { letter, two_digits, three_digits, number_base } = value

        const fields = [letter, two_digits, three_digits, number_base]
        const filled = fields.filter(v => v && String(v).trim() !== '')
        const empty = fields.filter(v => !v || String(v).trim() === '')

        return filled.length === 0 || empty.length === 0
      }
    )
  })
